// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"165":"shorts","464":"search","809":"account","922":"edit"}[chunkId] || chunkId) + "." + {"165":"679b2c67","464":"8c8eb9af","804":"e45f9e8d","809":"23addca3","922":"bed0f0a2","938":"fb8e33c0"}[chunkId] + ".js";
};